var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDropdownArrow = function SvgDropdownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 8,
    viewBox: "0 0 14 8"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.09 7.75c-.068 0-.137-.013-.202-.036-.082-.03-.158-.077-.22-.14l-.492-.49C6.064 6.97 6 6.815 6 6.657c0-.158.064-.312.176-.424l.712-.713L12.234.176C12.346.065 12.5 0 12.66 0c.156 0 .31.064.423.175l.49.492c.113.11.177.266.177.424 0 .16-.064.314-.176.425l-6.06 6.06c-.11.11-.265.175-.423.175M12.66.6l.423.424L12.66.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.34 0c-.068 0-.137.013-.202.036-.082.03-.158.077-.22.14l-.492.49C.314.78.25.935.25 1.093c0 .158.064.312.176.424l.712.713 5.346 5.345c.112.11.267.175.425.175.156 0 .31-.064.423-.175l.49-.492c.113-.11.177-.266.177-.424 0-.16-.064-.314-.176-.425L1.764.175C1.655.066 1.5 0 1.342 0m5.57 7.15l.423-.424-.424.424"
  }))));
};
export default SvgDropdownArrow;